module.exports = __webpack_public_path__ + "img/ic_stop.6adb36f6.png";